import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  CITY_GUIDE_CREATE,
  CITY_GUIDE_FILTER_STATUS_SUBMENU,
  CITY_GUIDE_VIEW,
} from '../../../../../constants/CityGuideConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_CMS_CITY_GUIDE,
} from '../../../../../constants/RoleConsts';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import SearchBar from '../../../../../shared/search-bar/Search-Bar';
import { changeCityGuideState, removeCityGuide } from '../../../../../utils/cmsUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import { createDataSortMapping } from '../../../../../utils/PropertyAPIUtils';
import {
  allCityGuideCategoriesSelector,
  cityGuideSelector,
  fetchAllCityGuide,
  setCityGuidesSuccess,
} from '../../../cmsSlice';
import CityGuideTable from './City-Guide-Table';
import MultipleDeleteConfirmationPopup from '../../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import {
  deleteSelectedItems,
  updateSelectedItemsStatus,
} from '../../../../../utils/ServicesAPIUtils';
import {
  ResetFilterList,
  generateConfirmationMessage,
  getCheckedIds,
  selectedCheckList,
  updateCheckedStatus,
} from '../../../../../utils/formUtils';
import MultipleSelectionAlert from '../../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const CityGuideList = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    hotelId,
    loader,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
  } = props;
  const originalCityGuides = useSelector(cityGuideSelector);
  const originalCategories = useSelector(allCityGuideCategoriesSelector);
  const dispatch = useDispatch();
  const [cityGuideList, setCityGuideList] = useState([]);
  const [filteredBaseList, setFilteredBaseList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
    cityGuide: {},
    modalType: '',
    type: '',
  });
  const [visible, setVisible] = useState(false);
  const wrapperRef = useRef(null);
  const [popUp, setPopUp] = useState(false);
  const [filterMenu, setFilterMenu] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [actionMenuList, setActionMenuList] = useState([]);
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [actionName, setActionName] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [showBulkSearchAlert, setShowBulkSearchAlert] = useState(false);
  const isFilterApplied = useRef(false);
  const prevHotelIdRef = useRef(hotelId);
  const [dragEnabled, setDragEnabled] = useState(true);
  const dragDisabled = !dragEnabled || cityGuideList?.length <= 1;

  useEffect(() => {
    if (originalCityGuides?.length) {
      const list = originalCityGuides.map((obj) => {
        const isChecked = cityGuideList?.some((room) => {
          return room.id === obj?.id && room?.isChecked;
        });
        const catObj = originalCategories.find((c) => c.id === obj.categoryId);
        const returnObj = {
          ...obj,
          category: catObj ? catObj.name : '',
          isChecked: false,
        };
        return returnObj;
      });
      setCityGuideList(list);
      setFilteredBaseList(list);
      setSearchText('');
    }
  }, [originalCityGuides, originalCategories]);

  const resetFilterDataList = () => {
    const updatedFilterMenu = [];
    if (originalCategories?.length) {
      const filterMenuCats = originalCategories.map((obj) => {
        return {
          id: obj.id,
          name: obj.name,
          selected: false,
        };
      });

      updatedFilterMenu.push(
        {
          title: 'All',
          field: 'all',
          subMenu: [],
        },
        {
          title: 'Categories',
          field: 'categoryId',
          subMenu: filterMenuCats,
        },
        {
          title: 'Status',
          field: 'status',
          subMenu: CITY_GUIDE_FILTER_STATUS_SUBMENU,
        },
      );
      setFilterMenu(updatedFilterMenu);
    }
  };

  useEffect(() => {
    resetFilterDataList();
  }, [originalCategories]);

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      cityGuide: null,
      modalType: '',
      type: '',
    });
  };

  const handleCellMenuClick = (event, currentCityGuide) => {
    if (selectedGuidesLength > 1) {
      setShowBulkKebabSelectionAlert(true);
    } else {
      setSelectedValue({
        id: currentCityGuide.id,
        name: currentCityGuide.name,
        title: '',
        description: '',
        status: false,
        anchorEl: event.currentTarget,
        cityGuide: currentCityGuide,
        modalType: '',
        type: '',
      });
    }
  };

  const onClickDeleteCityGuide = async () => {
    setSelectedValue((prev) => ({
      ...prev,
      title: 'Are you sure you want to delete',
      description: 'This action cannot be reversed',
      status: true,
      anchorEl: null,
      modalType: 'deleteModal',
    }));
  };

  const onDeleteCityGuide = async () => {
    try {
      const payload = {
        hotelId,
        id: selectedValue.id,
      };
      await removeCityGuide(payload);
      dispatch(fetchAllCityGuide(hotelId));
      notificationManager('success', 'City guide deleted successfully');
      handleClose();
    } catch (e) {
      if (e.graphQLErrors) notificationManager('danger', e.graphQLErrors[0].message);
      else notificationManager('danger', `Failed to deleted city guide`);
    }
  };

  const onClickRowViewDetails = (cityGuideItem, e, isClassDisabled) => {
    if (isClassDisabled) return onViewToggle(CITY_GUIDE_VIEW, true, cityGuideItem);
    if (e?.target?.tagName === 'TD') {
      onViewToggle(CITY_GUIDE_VIEW, true, cityGuideItem);
    }
  };

  const onViewDetails = () => {
    onViewToggle(CITY_GUIDE_VIEW, true, selectedValue.cityGuide);
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  useEffect(() => {
    setSearchText('');
    setCityGuideList((prevList) => {
      return originalCityGuides?.map((cityGuide) => {
        const isChecked = selectedCheckList(prevList, cityGuide.id);
        return {
          ...cityGuide,
          isChecked,
        };
      });
    });
  }, [originalCityGuides]);

  useEffect(() => {
    if (loading || cityGuideList?.length === 0) return;
    const totalItems = cityGuideList?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [cityGuideList?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== hotelId) {
      onsetPage(0);
    }
    prevHotelIdRef.current = hotelId;
  }, [hotelId]);

  const handleSearchText = (searchText) => {
    setSearchText(searchText);
    const checkedIdList = getCheckedIds(cityGuideList, 'isChecked');
    const filteredRows = filteredBaseList.filter((item) => {
      return item.name.toLowerCase().includes(searchText.toLowerCase());
    });
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    onsetPage(0);
    setCityGuideList(updatedCheckedList);
  };

  const handleFilter = (filterItems, field) => {
    if (field === 'all') {
      setFilteredBaseList(originalCityGuides);
      setCityGuideList(originalCityGuides);
      resetFilterDataList();
      isFilterApplied.current = false;
    } else {
      isFilterApplied.current = true;
      const filterIdWithFields = filterMenu
        .filter((initialFilter) => initialFilter.subMenu.length > 0)
        .map((filterItem) => {
          const subMenuFiltersId = filterItem.subMenu
            .filter((fItem) => fItem.selected === true)
            .map((fItemId) => fItemId.id);
          if (subMenuFiltersId.length > 0) {
            return {
              id: subMenuFiltersId,
              field: filterItem.field,
            };
          } else return null;
        })
        .filter((item) => item !== null);

      const filteredRecords = originalCityGuides?.filter((cityGuide) => {
        const doesFilterSatisfy = filterIdWithFields?.map((filter) => {
          if (filter.field === 'categoryId') {
            cityGuideList.filter((room) => {
              return filterItems.some((fItem) => fItem.id === room[field] && fItem.selected);
            });
          }

          if (filter.field === 'status') {
            const filterArray = filter.id.filter((ele) => {
              return (
                (ele === 'active' && cityGuide.isActive) ||
                (ele === 'inactive' && !cityGuide.isActive)
              );
            });
            return filterArray.length ? true : false;
          }

          return filter.id.includes(cityGuide[filter.field].toLowerCase());
        });
        return !doesFilterSatisfy.includes(false);
      });
      onsetPage(0);
      setFilteredBaseList(filteredRecords);
      setCityGuideList(filteredRecords);
    }
  };

  const onOpenDrawer = (event, type) => {
    if (selectedGuidesLength) {
      setCityGuideList(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.cityGuide);
    handleClose();
  };

  const onActiveDeActiveCityGuide = async (e, type) => {
    try {
      e.preventDefault();
      const payload = {
        hotelId,
        id: selectedValue.id,
        status: type === 'deactivate' ? false : true,
      };
      await changeCityGuideState(payload);
      dispatch(fetchAllCityGuide(hotelId));
      notificationManager('success', `City Guide ${type}d successfully`);
      handleClose();
    } catch (e) {
      if (e.graphQLErrors) notificationManager('danger', e.graphQLErrors[0].message);
      else notificationManager('danger', `Failed to ${type} city guide`);
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const handleAction = (actionName) => {
    let selectedValue = cityGuideList?.filter((City) => City?.isChecked);
    switch (actionName) {
      case 'Delete':
        if (selectedValue?.length > 0) {
          setShowMultipleDeleteConfirmation(true);
          setActionName('delete');
        }
        break;
      case 'Activate':
        if (selectedValue?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('activate');
          setIsActive(true);
        }
        break;
      case 'Deactivate':
        if (selectedValue?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('deactivate');
          setIsActive(false);
        }
        break;
      default:
        break;
    }
  };

  const handleSelectAll = (event) => {
    let selectedCityGuideList = [];
    let actionListName = [];
    const CheckedValue = event?.target?.checked;
    setIsAllSelected(CheckedValue);
    selectedCityGuideList = cityGuideList?.map((city) => {
      return {
        ...city,
        isChecked: CheckedValue,
      };
    });

    const isActive = selectedCityGuideList?.some((restaurant) => restaurant?.isActive);
    const isInactive = selectedCityGuideList?.some((restaurant) => !restaurant.isActive);

    if (isActive && !actionListName?.includes('Deactivate')) {
      actionListName.push('Deactivate');
    }
    if (isInactive && !actionListName?.includes('Activate')) {
      actionListName.push('Activate');
    }

    setCityGuideList([...selectedCityGuideList]);

    const sortActionMenuList = actionListName.sort((a, b) => {
      const order = { Activate: 1, Deactivate: 2, Delete: 3 };
      return order[a] - order[b];
    });

    setActionMenuList(sortActionMenuList);

    if (!event?.target?.checked && !selectedCityGuideList?.some((city) => city?.isChecked)) {
      setActionMenuList([]);
    }
  };

  const handleCheckboxChange = (id) => {
    let actionListName = [];
    let actionList = [];
    let index = cityGuideList?.findIndex((city) => city.id === id);
    if (!cityGuideList[index]?.isChecked) {
      cityGuideList[index] = { ...cityGuideList[index], isChecked: true };
    } else {
      cityGuideList[index].isChecked = !cityGuideList[index]?.isChecked;
    }
    setCityGuideList([...cityGuideList]);

    actionList = cityGuideList?.filter((city) => city?.isChecked).map((status) => status?.isActive);

    const checkedItems = cityGuideList?.filter((city) => city?.isChecked);

    if (checkedItems.length === 0) {
      setActionMenuList([]);
      setIsAllSelected(false);
      return;
    }

    const isActiveSelected = actionList.includes(true);
    const isInactiveSelected = actionList.includes(false);

    if (isActiveSelected && isInactiveSelected) {
      actionListName.push('Activate', 'Deactivate');
    } else if (isActiveSelected) {
      actionListName.push('Deactivate');
    } else if (isInactiveSelected) {
      actionListName.push('Activate');
    }

    const isAllSelected = cityGuideList?.every((city) => city?.isChecked);
    setIsAllSelected(isAllSelected);
    setActionMenuList(actionListName);
  };

  const getCheckedCityGuidesList = cityGuideList?.filter((cityGuide) => cityGuide?.isChecked);
  const listOfCityGuideIds = getCheckedCityGuidesList?.map((cityguide) => cityguide.id);
  const selectedGuidesLength = getCheckedCityGuidesList?.length;

  const onApiCallConfirmationNotification = generateConfirmationMessage(
    'City Guide',
    listOfCityGuideIds?.length,
    isActive,
  );

  const handleMultipleStatusChange = async (status) => {
    setActionMenuList([]);
    try {
      dispatch(stepUpLoaderCount());
      setLoading(true);
      const filterApplied = searchText?.length > 0 || isFilterApplied?.current ? true : false;
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'CITY_GUIDE';
      await updateSelectedItemsStatus(
        listOfCityGuideIds,
        hotelId,
        selectedLang,
        moduleName,
        '',
        isActive,
        filterApplied ? false : isAllSelected,
      );
      dispatch(fetchAllCityGuide(hotelId));
      notificationManager('success', onApiCallConfirmationNotification);
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        activate: false,
        brand: null,
      });
      setLoading(false);
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors
          ? e.graphQLErrors[0].message
          : 'The status of the City Guide was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setCityGuideList(ResetFilterList);
  };

  const deleteMultipleSelection = async () => {
    handleClose();
    resetFilterDataList();
    try {
      dispatch(stepUpLoaderCount());
      setLoading(true);
      const filterApplied = searchText?.length > 0 || isFilterApplied?.current ? true : false;
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'CITY_GUIDE';
      await deleteSelectedItems(
        listOfCityGuideIds,
        hotelId,
        selectedLang,
        moduleName,
        '',
        filterApplied ? false : isAllSelected,
      );
      dispatch(fetchAllCityGuide(hotelId));
      notificationManager('success', 'City Guide deleted successfully');
      setSelectedValue({
        ...selectedValue,
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
      setLoading(false);
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Failed to delete City Guide',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setActionMenuList([]);
    setCityGuideList(ResetFilterList);
  };

  const handleBulkSearchAlertClose = () => {
    setShowBulkSearchAlert(false);
    setSearchText('');
    setCityGuideList(
      originalCityGuides?.map((res) => ({
        ...res,
        isChecked: false,
      })),
    );
  };

  return (
    <div className='mt-4 mb-4 group-list-container city-guide-list'>
      <SearchBar
        type={CITY_GUIDE_CREATE}
        buttonName='Add Activity'
        setSearchText={handleSearchText}
        onOpenDrawer={onOpenDrawer}
        displayAddOrEdit={
          permissions[RBAC_TYPE_CMS_CITY_GUIDE] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
            ? 'show'
            : 'hide'
        }
        visible={visible}
        setVisible={setVisible}
        popUp={popUp}
        setPopUp={setPopUp}
        placeHolder={cityGuideList}
        setPlaceHolder={setCityGuideList}
        globalPlaceHolder={originalCityGuides}
        setGlobalPlaceHolder={setCityGuidesSuccess}
        globalCategoryPlaceHolder={originalCategories}
        dispatch={dispatch}
        mappingApi={createDataSortMapping}
        displayText='City guide'
        module='CITY_GUIDE'
        filterList={filterMenu}
        setFilterDataList={setFilterMenu}
        filteredRecoard={handleFilter}
        searchText={searchText}
        setSearch={setSearchText}
        actionMenuItems={actionMenuList ?? []}
        handleAction={handleAction ?? false}
        setDrag={setDragEnabled}
      />
      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {loader && (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        )}
        <CityGuideTable
          page={page}
          rowsPerPage={rowsPerPage}
          onOpenDrawer={onOpenDrawer}
          onClickRowViewDetails={onClickRowViewDetails}
          onViewDetails={onViewDetails}
          selectedValue={selectedValue}
          handleClose={handleClose}
          handleCellMenuClick={handleCellMenuClick}
          list={cityGuideList}
          setCityGuideList={setCityGuideList}
          permissions={permissions}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          onClickDelete={onClickDeleteCityGuide}
          onActiveDeActiveCityGuide={onActiveDeActiveCityGuide}
          setVisible={setVisible}
          searchText={searchText}
          handleSelectAll={handleSelectAll}
          isAllSelected={isAllSelected}
          setIsAllSelected={setIsAllSelected}
          handleCheckboxChange={handleCheckboxChange}
          setActionMenuList={setActionMenuList}
          selectedGuidesLength={selectedGuidesLength}
          dragDisabled={dragDisabled}
        />
      </div>
      {selectedValue.status && selectedValue.modalType === 'deleteModal' && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={onDeleteCityGuide}
          onDeleteCancel={handleClose}
        />
      )}
      {showMultipleDeleteConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedGuidesLength} ${
            selectedGuidesLength > 1 ? 'city guides' : 'city guide'
          } will be ${actionName}d. This Action is irreversible.`}
          isOpen={showMultipleDeleteConfirmation}
          onClose={() => setShowMultipleDeleteConfirmation(false)}
          onConfirm={() => {
            deleteMultipleSelection();
          }}
          leftButtonName={'Cancel'}
          rightButtonName={'Delete'}
        />
      )}

      {showBulkActiveDeactiveConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedGuidesLength}  ${
            selectedGuidesLength > 1 ? 'city guides' : 'city guide'
          } will be ${actionName}d.`}
          isOpen={showBulkActiveDeactiveConfirmation}
          onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
          onConfirm={() => {
            handleMultipleStatusChange();
          }}
          leftButtonName={'No'}
          rightButtonName={'Yes'}
        />
      )}
      {showBulkSearchAlert && (
        <MultipleSelectionAlert
          isOpen={showBulkSearchAlert}
          onClose={handleBulkSearchAlertClose}
          message="If you perform a search after making selections, the items you've selected will be lost."
          ButtonName='Cancel'
        />
      )}
      {showBulkKebabSelectionAlert && (
        <MultipleSelectionAlert
          isOpen={showBulkKebabSelectionAlert}
          onClose={() => setShowBulkKebabSelectionAlert(false)}
          message='Please select one item from the list that you want to edit.'
          centerButtonName='OK'
        />
      )}
    </div>
  );
};

export default CityGuideList;
